import { storeProviderOf } from '@/lib/billing/storeBilling';
import { isPaidSubscription, type SubscriptionLike } from '@/lib/quota/isPaidSubscription';

export interface WalletRenewalSubscriptionLike extends SubscriptionLike {
  past_due?: boolean | null;
  cancellation_at?: string | Date | null;
  next_payment_at?: string | Date | null;
  wallet_plan_until?: string | Date | null;
}

export type WalletRenewalEligibility =
  | { ok: true; path: 'pix' | 'grant' }
  | { ok: false; code: 'renewal_not_due' | 'not_eligible' };

export function resolveWalletRenewalEligibility({
  subscription,
}: {
  subscription: WalletRenewalSubscriptionLike | null | undefined;
  now: Date;
}): WalletRenewalEligibility {
  if (!subscription || !isPaidSubscription(subscription)) {
    return { ok: false, code: 'not_eligible' };
  }
  if (subscription.payment_provider === 'pagarme') {
    return { ok: true, path: 'pix' };
  }
  const hasStripe =
    subscription.payment_provider === 'stripe' || !!subscription.stripe_subscription_id;
  const hasEduzz = subscription.payment_provider === 'eduzz';
  const hasStore = storeProviderOf(subscription) !== null;
  if (!subscription.wallet_plan_until || hasStripe || hasEduzz || hasStore) {
    return { ok: false, code: 'not_eligible' };
  }
  return { ok: true, path: 'grant' };
}
